import React, { Component } from 'react';
import { Space, Row, Col, Typography, message, Table, Popconfirm } from 'antd';
import { AppstoreOutlined, DownloadOutlined, SearchOutlined, SendOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import axios from 'axios';
import {
    ModalItem,
    InputItem,
    ButtonItem,
} from '../../../../Components/Items';
import debounce from "lodash.debounce";
import moment from 'moment';

const { Text } = Typography;

class ModalMandarAWorkBench extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
            workbenches: [],
            totalWorkbenches: 0,
            loading: false,
            currentPage: 1,
            pageSize: 10
        };

        // Aquí defines la función debounced
        this.debouncedConsultar = debounce(() => {
            this.consultarWorkbenches();
        }, 500); // Puedes ajustar el delay en ms (ej. 500)
    }

    // Consultar workbenches cuando se abre el modal
    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.consultarWorkbenches();
        }
    }


    // Consultar insumos desde la API
    consultarWorkbenches = () => {
        this.setState({ loading: true });

        const { searchTerm, currentPage, pageSize } = this.state;

        axios
            .post(
                "requisiciones/selectWorkBenchPaginado",
                {
                    empresaId: this.props.empresaId,
                    proveedorId: this.props.proveedorId,
                    query: searchTerm,
                    skip: (currentPage - 1) * pageSize,
                    limit: pageSize,
                    blockId: this.props.requisicionId,
                },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        workbenches: res.data.items.map((value) => {
                            return {
                                ...value,
                                proveedorNombre: value?.proveedor?.nombre ? ((value?.proveedor?.nombre || "") + " " + (value?.proveedor?.apellidoPaterno || "") + " " + (value?.proveedor?.apellidoMaterno || ""))
                                    : (value?.proveedor?.razonSocial || ""),
                                accion: {
                                    _id: value._id,
                                    estado: value.estado,
                                    xml: value.xml,
                                    estadoFactura: value.estadoFactura,
                                    requisicion: value.requisicion,
                                    finiquitada: value.finiquitada,
                                },
                            };
                        }),
                        totalWorkbenches: res.data.total,
                        loading: false
                    });
                } else {
                    message.error("No se encontraron workbenches");
                    this.setState({ loading: false });
                }
            })
            .catch((error) => {
                console.error("Error al consultar workbenches:", error);
                message.error("Error al consultar workbenches");
                this.setState({ loading: false });
            });

    };

    onSearchChange = (e) => {
        this.setState({ searchTerm: e.target.value, currentPage: 1 }, () => {
            this.debouncedConsultar();
        });
    };

    onTableChange = (pagination) => {
        this.setState(
            {
                currentPage: pagination.current,
                pageSize: pagination.pageSize
            },
            () => {
                this.consultarWorkbenches();
            }
        );
    };

    // Limpiar filtros al cerrar el modal
    handleCancel = () => {
        this.setState({
            searchTerm: '',
            workbenches: [],
            currentPage: 1
        });
        this.props.onCancel();
    };

    confirmarWorkbench(workbenchId) {
        this.props.onConfirm(workbenchId);
    }

    // Columnas de la tabla de productos
    getColumnsWorkbenches = () => [
        {
            title: "Numero",
            dataIndex: "numero",
            key: "numero",
            render: (value, record) => `${record.serie || "M"} ${value}`,
            width: "10%",
        },
        {
            title: "Proyecto",
            dataIndex: "proyecto",
            key: "proyecto",
            sorter: (a, b) => {
                if (a.proyecto.nombre < b.proyecto.nombre) {
                    return -1;
                }
                if (a.proyecto.nombre > b.proyecto.nombre) {
                    return 1;
                }
                return 0;
            },
            render: (value) => value.nombre,
            width: "10%",
            ellipsis: true,
        },
        {
            title: "Proveedor",
            dataIndex: "proveedorNombre",
            key: "proveedorNombre",
            sorter: (a, b) => {
                if (a.proveedorNombre < b.proveedorNombre) {
                    return -1;
                }
                if (a.proveedorNombre > b.proveedorNombre) {
                    return 1;
                }
                return 0;
            },
            buscar: 'proveedorNombre',
            render: (value, record) => {
                let buttons = [];

                if (record.enviada) {
                    buttons.push(<SendOutlined />)
                }

                if (record.descargada) {
                    buttons.push(<DownloadOutlined />)
                }

                return <Space size="small">{buttons}{value}</Space>

            },
            width: "13%",
            ellipsis: true,
        },
        {
            title: "Observaciones",
            dataIndex: "observaciones",
            key: "observaciones",
            sorter: (a, b) => {
                if (a.observaciones < b.observaciones) {
                    return -1;
                }
                if (a.observaciones > b.observaciones) {
                    return 1;
                }
                return 0;
            },
            width: "10%",
            ellipsis: true,
        },
        {
            title: "Fecha",
            dataIndex: "createdAt",
            key: "createdAt",
            sorter: (a, b) => {
                if (moment(a.createdAt) < moment(b.createdAt)) {
                    return -1;
                }
                if (moment(a.createdAt) > moment(b.createdAt)) {
                    return 1;
                }
                return 0;
            },
            render: (value) => moment(value).locale("es").format("L"),
            width: "10%",
            ellipsis: true,
            align: "center",
        },
        {
            title: "Acción",
            dataIndex: "accion",
            key: "accion",
            render: (value, record, index) => {
                return (
                    <>

                        <Popconfirm
                            title={`Confirma la eleccion de esta workbench ${record.serie || "M"} ${record.numero}?`}
                            onConfirm={() => this.confirmarWorkbench(record._id)}
                            okText="Sí"
                            cancelText="No"
                        >
                            <ButtonItem
                                type="primary"
                                icon={<AppstoreOutlined />}
                                verde
                                lessTime
                            >
                                Elegir
                            </ButtonItem>
                        </Popconfirm>
                    </>
                );

            },
            width: "10%",
            ellipsis: true,
        },
    ];

    render() {
        const { visible } = this.props;
        const { loading, workbenches, currentPage, pageSize, totalWorkbenches } = this.state;

        return (
            <ModalItem
                title={
                    <Space>
                        <AppstoreOutlined style={{ color: '#00b5e2' }} />
                        <span>WorkBench</span>
                    </Space>
                }
                visible={visible}
                onCancel={this.handleCancel}
                footer={null}
                width={1200}
                style={{ top: 20 }}
                destroyOnClose={true}
                spinning={loading}
                zIndex={1000}
            >
                {/* Filtros */}
                <Row gutter={16} style={{ marginBottom: '16px' }}>
                    <Col span={24}>
                        <InputItem
                            prefix={<SearchOutlined />}
                            placeholder="Buscar workbench..."
                            value={this.state.searchTerm}
                            onChange={this.onSearchChange}
                            size="large"
                            allowClear
                            autoFocus
                        />
                    </Col>
                </Row>

                {/* Información de resultados */}
                <div style={{ marginBottom: '16px' }}>
                    <Text style={{ fontSize: '14px', color: '#666' }}>
                        Mostrando {workbenches.length} de {totalWorkbenches} workbenches
                    </Text>
                </div>

                {/* Tabla de workbenches */}
                <Table
                    dataSource={workbenches}
                    columns={this.getColumnsWorkbenches()}
                    spinning={loading}
                    pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        total: totalWorkbenches,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        showTotal: (total, range) =>
                            `${range[0]}-${range[1]} de ${total} workbenches`,
                        pageSizeOptions: ['10', '20', '50'],
                        showLessItems: true,
                        hideOnSinglePage: false,
                        simple: false
                    }}
                    onChange={this.onTableChange}
                    scroll={{ y: 400 }}
                    locale={{
                        emptyText: loading ? 'Cargando workbench...' : 'No se encontraron workbenchs',
                    }}
                />
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(ModalMandarAWorkBench);